import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddRevenueComponent } from './add-revenue/add-revenue.component';
import { AdjustBillingComponent } from './adjust-billing/adjust-billing.component';
import { AdjustmentsHomeComponent } from './adjustments-home/adjustments-home.component';
import { AdjustmentsRoutingModule } from './adjustments-routing.module';
import { PaymentComponent } from './payment/payment.component';
import { AgingCommentsComponent } from './aging-comments/aging-comments.component';
import { GbInvoiceAdjustmentsComponent } from './adjust-billing/gb-invoice-adjustments/gb-invoice-adjustments.component';
import { MiInvoiceAdjustmentsComponent } from './adjust-billing/mi-invoice-adjustments/mi-invoice-adjustments.component';
import { ProcessingBannerComponent } from 'src/app/shared/ui/processing-banner/processing-banner.component';
import { SuccessBannerComponent } from 'src/app/shared/ui/success-banner/success-banner.component';
import { ErrorBannerComponent } from 'src/app/shared/ui/error-banner/error-banner.component';

@NgModule({
  imports: [
    AdjustmentsRoutingModule,
    SharedModule,
    ProcessingBannerComponent,
    SuccessBannerComponent,
    ErrorBannerComponent,
  ],
  exports: [
    AddRevenueComponent,
    AdjustBillingComponent,
    AddRevenueComponent,
    PaymentComponent,
    AgingCommentsComponent,
    GbInvoiceAdjustmentsComponent,
    MiInvoiceAdjustmentsComponent,
    AdjustmentsHomeComponent,
  ],
  declarations: [
    AdjustmentsHomeComponent,
    AddRevenueComponent,
    AdjustBillingComponent,
    AddRevenueComponent,
    PaymentComponent,
    AgingCommentsComponent,
    GbInvoiceAdjustmentsComponent,
    MiInvoiceAdjustmentsComponent,
  ],
})
export class AdjustmentsModule {}
